import styled from 'styled-components'
import { useCourseWithSavedCoupon } from 'querys/course'
import PricingSection from 'components/prices/pricing-section'

const PricesStyled = styled.section`
  scroll-margin-top: 80px;
  .ppp-banner {
    position: static!important;
  }
`

function Prices() {
  const { data: course, isLoading } = useCourseWithSavedCoupon()

  if (!course || isLoading) return null

  const {
    is_free, price, discount, original_price, slug,
  } = course

  const coursePrice = {
    discount: discount?.status === 'VALID' ? discount : null,
    original_price: discount?.status === 'VALID' ? original_price : null,
    is_free,
    price,
    slug,
  }

  return (
    <PricesStyled aria-labelledby="comprar-title" id="comprar">
      <PricingSection coursePrice={coursePrice} />
    </PricesStyled>
  )
}

export default Prices
